import apiClient from "../apiClient";

const resource = "directorsAppointments";

export default {
    getAll: params => apiClient.get(`${resource}?${params}`),
    getDetails: id => apiClient.get(`${resource}/${id}/details`),
    add: payload => apiClient.post(`${resource}`, payload),
    getAssignments: () => apiClient.get(`${resource}/Assignments`),
    getCurrenttDirector: (params) => apiClient.get(`${resource}/CurrenttDirector?${params}`),
    approval: id => apiClient.put(`${resource}/${id}/approval`),
    cancel: id => apiClient.put(`${resource}/${id}/cancel`),
    delete: id => apiClient.delete(`${resource}/${id}`),

};
